import Cookies from 'js-cookie';
import { DateTime as FunctionsDatetime, General as FunctionsGeneral } from './functions';
import { User as ConstantsUser } from './constants';

export const refreshTokenName = 'refreshToken';
export const accessTokenName = 'accessToken';
export const noTokenValue = 'noToken';

export function checkAuth() {
  return getAccessToken() || getRefreshToken() ? true : false;
}

export function getRefreshToken() {
  return Cookies.get(refreshTokenName);
}

export function getAccessToken() {
  return Cookies.get(accessTokenName);
}

export function removeTokens() {
  Cookies.remove(refreshTokenName);
  Cookies.remove(accessTokenName);
}

export function setRefreshToken(refreshToken) {
  Cookies.set(refreshTokenName, refreshToken, { expires: 30 });
}

export function setAccessToken(accessToken) {
  var exp = FunctionsDatetime.addMinutes(new Date(), 1);
  Cookies.set(accessTokenName, accessToken, { expires: exp });
}

export function setUser(user) {
  localStorage.setItem('user', JSON.stringify(user));
}

export function getUser() {
  const item = localStorage.getItem('user');
  return item ? JSON.parse(item) : false;
}

export function setSystemSetting(systemSetting) {
  localStorage.setItem('systemSetting', JSON.stringify(systemSetting));
}

export function getSystemSetting() {
  const item = localStorage.getItem('systemSetting');
  return item ? JSON.parse(item) : {};
}

export function setIsMaintenance(isMaintenance) {
  localStorage.setItem('isMaintenance', isMaintenance);
}

export function isMaintenance() {
  const isMaintenance = localStorage.getItem('isMaintenance');
  return isMaintenance?.toLowerCase() === "true";
}

export function getUserApiPath() {
  const user = getUser();
  if (user) {
    const role = FunctionsGeneral.getConstant(ConstantsUser.Role, user.roleCode).this;
    return role.apiPath;
  }
  return "";
}

export function removeUser() {
  localStorage.removeItem('user');
}

export function makeBearerToken(token) {
  return token ? `Bearer ${token}` : noTokenValue;
}

export function getBearerAccessToken() {
  const accessToken = getAccessToken();
  return accessToken ? `Bearer ${accessToken}`: noTokenValue;
}

export function getBearerRefreshToken() {
  const refreshToken = getRefreshToken();
  return refreshToken ? `Bearer ${refreshToken}`: noTokenValue;
}
